import { render, staticRenderFns } from "./BorderBox8.vue?vue&type=template&id=2b1c803d"
import script from "./BorderBox8.vue?vue&type=script&lang=js"
export * from "./BorderBox8.vue?vue&type=script&lang=js"
import style0 from "./BorderBox8.vue?vue&type=style&index=0&id=2b1c803d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports